import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, a = /* @__PURE__ */ e("g", { "clip-path": "url(#a)" }, [
  /* @__PURE__ */ e("path", {
    "fill-rule": "evenodd",
    d: "M12.81.25H7.25v4.514L.386 14.57a.75.75 0 1 0 1.228.86L4.4 11.45a.755.755 0 0 0 .07.08L6 13.06l2-2 2 2 1.53-1.53a.754.754 0 0 0 .07-.08l2.786 3.98a.75.75 0 0 0 1.228-.86L8.75 4.763V3.75h4.06L11.06 2 12.81.25Zm-2.028 10.032L8 6.308l-2.782 3.974a.746.746 0 0 1 .312.188l.47.47 2-2 2 2 .47-.47a.747.747 0 0 1 .312-.188Z",
    "clip-rule": "evenodd"
  })
], -1), n = /* @__PURE__ */ e("defs", null, [
  /* @__PURE__ */ e("clipPath", { id: "a" }, [
    /* @__PURE__ */ e("path", { d: "M0 0h16v16H0z" })
  ])
], -1), c = [
  a,
  n
];
function d(r, s) {
  return t(), o("svg", l, [...c]);
}
const i = { render: d };
export {
  i as default,
  d as render
};
